var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 10,
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.837029 8.40599C1.74962 7.59643 2.65883 6.74782 3.38318 5.76271C3.5181 5.57923 3.61797 5.42135 3.68171 5.29388C3.75399 5.14931 3.75399 5.10098 3.68171 4.95641C3.61797 4.82894 3.5181 4.67106 3.38319 4.48758C2.65958 3.50347 1.75163 2.65097 0.837345 1.84455C0.578259 1.61651 0.552785 1.22137 0.780805 0.962252C1.00884 0.703123 1.40376 0.677914 1.66289 0.905948C2.64464 1.77159 3.61342 2.6906 4.39025 3.74709C4.68008 4.14126 5 4.61628 5 5.12514C5 5.63401 4.68008 6.10904 4.39024 6.5032C3.61615 7.55596 2.63729 8.48014 1.66316 9.34407C1.40403 9.5721 1.0088 9.54717 0.780767 9.28803C0.552749 9.02892 0.577942 8.63403 0.837029 8.40599Z",
    fill: "#1F2445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.58a517192bc6ef3eca245ef479ac8f1d.svg";
export { ForwardRef as ReactComponent };